import { RouterModule, Routes } from '@angular/router';
import { PublicPagesComponent } from './public-pages.component';
import { LogInComponent } from './log-in/log-in.component';

const PagesRoutes: Routes = [
    {
        path: 'pb',
        component: PublicPagesComponent,
        children: [
            {   path: 'log-in',
                component: LogInComponent
            },
            {
              path: 'not-found',
              loadChildren: () => import("./not-found/not-found.module").then(module => module.NotFoundModule)
            }
        ]
    }
];

export const PublicPagesRoutes = RouterModule.forChild(PagesRoutes);
